<template>
  <div>
    <b-modal id="modalEditCoefficientScheme" ref="modalEditCoefficientScheme" :title="$t('Coefficient scheme detail')" hide-footer>
      <div v-if="editItem">
        <b-form-group label-align="right" :label="$t('Full name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="editItem.name" aria-describedby="inputFeedbackName" :state="editItem.name.length > 0"/>
          <b-form-invalid-feedback id="inputFeedbackName">
            {{ $t('Enter title') }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Comment')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="editItem.comment"/>
        </b-form-group>

        <b-form-group label-align="right" :label="$t('Accounting periods range')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <md-button @click="addCost" class="md-raised">{{ $t('Add') }}</md-button>
          <i  id="qustionMark" class="primary fa fa-question fa-lg" style="margin-left:0rem;margin-top:0.85rem"/>
                <b-tooltip :placement="'rightbottom'" target="qustionMark" triggers="hover">
                  {{ $t('CoefSchemeExample') }}
                </b-tooltip>
        </b-form-group>

        <b-table striped hover small responsive
          :items="editItem.items"
          :fields="coefficientFields">
          <template v-slot:cell(delay)="row">
            <b-form-input type="number" style="max-height:25px" v-model="row.item.delay"/>
          </template>
          <template v-slot:cell(duration)="row">
            <b-form-input type="number" style="max-height:25px" v-model="row.item.duration"/>
          </template>
          <template v-slot:cell(coeff)="row">
            <b-form-input style="max-height:25px" v-model="row.item.coeff"/>
          </template>
          <template v-slot:cell(actions)="row">
            <i @click.stop="deleteCostsValue(row)" class="danger fa fa-trash-alt fa-lg"/>
          </template>
        </b-table>

        <modal-ok-cancel @save="save" @cancel="$bvModal.hide('modalEditCoefficientScheme')" />
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    editItem: null
  },
  data () {
    return {
      coefficientFields: [
        {key: 'delay', label: this.$i18n.t('Since Accounting period count'), sortable: true},
        {key: 'duration', label: this.$i18n.t('Till Accounting period count'), sortable: true},
        {key: 'coeff', label: this.$i18n.t('Coefficient (fraction)'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      deleteCost: require('@/assets/img/document_delete.png')
    }
  },
  methods: {
    addCost () {
      let newCost = {
        scheme_id: 0,
        delay: 0,
        duration: 1,
        coeff: 1
      }
      if (this.editItem.items.length > 0) {
        let copy = JSON.parse(JSON.stringify(this.editItem.items))
        let arr = copy.pop()
        newCost.delay = Number(arr.duration)
        newCost.duration = Number(arr.duration) + 1
      }
      if (this.editItem.id > 0) {
        newCost.scheme_id = this.editItem.id
      }
      this.editItem.items.push(newCost)
    },
    deleteCostsValue (row) {
      this.editItem.items = this.editItem.items.filter((value) => {
        return value !== row.item
      })
    },
    save () {
      if (!this.editItem.name) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Full name fields is invalid'), 'Error')
        return
      }
      this.editItem.costs = []
      for (let el of this.editItem.items) {
        let newEl = {
          delay: 0,
          duration: 0,
          coeff: 0,
          scheme_id: 0
        }
        newEl.delay = Number(el.delay)
        newEl.duration = Number(el.duration)
        newEl.coeff = Number(el.coeff)
        newEl.scheme_id = el.scheme_id
        if (newEl.delay > newEl.duration) {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Table Cost is filled invalid, Since > Until'), 'Error')
          return
        }
        this.editItem.costs.push(newEl)
      }
      for (let i = 0; i < this.editItem.costs.length; i++) {
        if (i > 0) {
          if ((this.editItem.costs[i - 1].duration) !== this.editItem.costs[i].delay) {
            this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Table Cost is filled invalid, items not continuesly ( correct example: 0 - 1 ; 1 - 10 )'), 'Error')
            return
          }
        }
      }
      this.editItem.coeff_scheme_id = this.editItem.id
      let response = this.editItem.id !== 0
        ? this.$store.dispatch('Tariffing/UPDATE_COEFFICIENT_SCHEME', this.editItem)
        : this.$store.dispatch('Tariffing/CREATE_COEFFICIENT_SCHEME', this.editItem)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Tariffing/GET_COEFFICIENT_SCHEME')
          this.$refs.modalEditCoefficientScheme.hide()
          this.$root.$emit('makeToasts')
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/tariffication/additional/coefficientScheme/editModal.vue